import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import values from 'lodash/values'

import TabSlider from './TabSlider'
import { chooseActiveTabById } from '../actions'
import { getActiveTab } from '../selectors'

const DetailsTabs = ({ tabs, type, ID, hash, defaultTabIndex, openInModal }) => {
  const dispatch = useDispatch()

  const activeTab = useSelector((state) => getActiveTab(state, { type, ID }))

  function chooseActiveTab(tab) {
    dispatch(chooseActiveTabById({ tab, type, ID, hash }))
  }

  return (
    <TabSlider
      name={`${type}-${ID}-Details`}
      activeTab={activeTab}
      chooseActiveTab={chooseActiveTab}
      tabs={values(tabs)}
      defaultTabIndex={defaultTabIndex}
      openInModal={openInModal}
    />
  )
}

export default withRouter(DetailsTabs)
